import { render, staticRenderFns } from "./PageManagement.vue?vue&type=template&id=7a7c8b6c&scoped=true&"
import script from "./PageManagement.vue?vue&type=script&lang=js&"
export * from "./PageManagement.vue?vue&type=script&lang=js&"
import style0 from "./PageManagement.vue?vue&type=style&index=0&id=7a7c8b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7c8b6c",
  null
  
)

export default component.exports